import React, { useState } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastHeader from 'react-bootstrap/ToastHeader';
import { useHistory } from 'react-router-dom';
import { CentsDataGridServer } from 'components/common/dataGrid/dataGridServer';
import TableSearchBar from 'components/common/search/TableSearchBar';
import { usePaginatedTableQuery } from 'hooks/usePaginatedTableQuery';
import { DEFAULT_PAGE_LIMIT } from 'utils/constants';
import {
  downloadStatementDescriptorsReport,
  searchBusinesses,
} from 'api/admin/businesses/businesses';

const COLUMNS = [
  { headerName: 'ID', field: 'id', flex: 0.5 },
  { headerName: 'Name', field: 'name', flex: 1 },
  { headerName: 'Business Owner Name', field: 'businessOwnerName', flex: 1 },
  { headerName: 'Business Owner Email', field: 'businessOwnerEmail', flex: 2 },
  { headerName: 'Business Type', field: 'type', flex: 1 },
  { headerName: 'Address', field: 'address', flex: 1 },
  { headerName: 'City', field: 'city', flex: 1 },
  { headerName: 'State', field: 'state', flex: 1 },
  { headerName: 'Zip Code', field: 'zipCode', flex: 1 },
  { headerName: 'Stripe Connect ID', field: 'merchantId', flex: 1 },
  { headerName: 'Stripe Customer Token', field: 'stripeCustomerToken', flex: 1 },
  { headerName: 'Created At', field: 'createdAt', flex: 1 },
];

const BusinessesTable = () => {
  const history = useHistory();
  const [showSuccessNotification, setShowSuccessNotification] = useState('');
  const {
    data,
    isLoading,
    pageNumber,
    pageSize,
    searchInput,
    handleSearch,
    sortModel,
    handleSortModelChange,
    handlePageChange,
  } = usePaginatedTableQuery({
    queryKey: 'searchBusinesses',
    queryFn: async ({ searchInput, pageNumber, pageSize, sortBy, sortOrder }) => {
      const { data } = await searchBusinesses(searchInput, pageNumber, pageSize, sortBy, sortOrder);
      return { businesses: data.businesses, total: data.total };
    },
    errorMessage: 'Failed to load businesses. Showing last loaded results.',
    defaultPageSize: DEFAULT_PAGE_LIMIT,
  });
  const { businesses, total } = data ?? {};

  const handleRowClick = ({ id }) => {
    history.push(`/businesses/${Number(id)}`);
  };

  const handleCreateBusinessClick = () => {
    history.push('/businesses/new');
  };

  const handleStatementDescriptorsClick = async () => {
    await downloadStatementDescriptorsReport();
    setShowSuccessNotification(true);
  };

  return (
    <div className="page-container">
      <div className="businesses-header">
        <h1>Businesses</h1>
        <div>
          <button
            className="statement-descriptors-button"
            onClick={handleStatementDescriptorsClick}
          >
            Download Statement Descriptors
          </button>
          <button onClick={handleCreateBusinessClick}>Create Business</button>
        </div>
      </div>
      {showSuccessNotification && (
        <Toast
          delay={5000}
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: 50,
            margin: '0 auto',
            zIndex: 9999,
            backgroundColor: '#28a745',
          }}
          autohide
        >
          <ToastHeader closeButton={false}>Report will be emailed to you!</ToastHeader>
        </Toast>
      )}
      <div className="businesses-search-bar">
        <TableSearchBar value={searchInput} placeholder="Find a business" onSearch={handleSearch} />
      </div>
      <CentsDataGridServer
        tableName="BUSINESSES"
        data={businesses ?? []}
        columns={COLUMNS}
        onRowClick={handleRowClick}
        isLoading={isLoading}
        rowCount={total ?? 0}
        pageSize={pageSize}
        page={pageNumber}
        onPageChange={handlePageChange}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        defaultColumnVisibilityModel={{
          stripeCustomerToken: false,
        }}
      />
    </div>
  );
};

export default BusinessesTable;
